/* eslint-disable @typescript-eslint/no-unused-vars */
import { lazy, Suspense } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import LoaderScreen from './LoaderScreen';
const MainLayout = lazy(() => import('src/MainLayout'));
const DowntimePage = lazy(() => import('src/DowntimePage'));
const ResetPasswordConfirmation = lazy(() => import('src/screens/AuthFlow/ResetPasswordConfirmation/ResetPasswordConfirmation'));
const ForgotPassword = lazy(() => import('src/screens/AuthFlow/ForgotPassword/ForgotPassword'));
const Login = lazy(() => import('src/screens/AuthFlow/Login/Login'));
const ResetPassword = lazy(() => import('src/screens/AuthFlow/ResetPassword/ResetPassword'));
const ReviewOrder = lazy(() => import('src/screens/ReviewOrder/ReviewOrder'));
const OrderConfirmed = lazy(() => import('src/screens/ReviewOrder/components/OrderConfirmed'));
const ViewSubmission = lazy(() => import('src/screens/ReviewOrder/ViewSubmission'));
const EmailsListingPage = lazy(() => import('src/screens/ListingPage/EmailsListingPage'));
const MultiPoListingPage = lazy(() => import('src/screens/ListingPage/components/MultiPoListingPage'));
const NylasEmailSettings = lazy(() => import('src/screens/Settings/NylasEmailSettings/NylasEmailSettings'));
const GeneralSettings = lazy(() => import('src/screens/Settings/GeneralSettings/GeneralSettings'));
const AdvancedSettings = lazy(() => import('src/screens/Settings/AdvancedSettings/AdvancedSettings'));
const NylasCallback = lazy(() => import('src/screens/Settings/NylasCallback/NylasCallback'));
const PromptManagement = lazy(() => import('src/screens/PromptManagement/PromptManagement'));
const NotFound404 = lazy(() => import('src/common/NotFound404'));
const LoginTwoFactor = lazy(() => import('src/screens/AuthFlow/LoginTwoFactor/LoginTwoFactor'));
const Impersonate = lazy(() => import('src/screens/AuthFlow/Impersonate/Impersonate'));
const ManualUpload = lazy(() => import('src/screens/ManualUpload/ManualUpload'));
const OrderComparison = lazy(() => import('src/screens/OrderComparison/OrderComparison'));
const UserManagementSystem = lazy(() => import('src/screens/UserManagementSystem/UserManagement'));

const RouteNames = {
	cart: {
		path: '/cart-summary',
	},
	home: {
		path: '/',
	},
	login_two_factor: {
		path: '/login/2fa',
	},
	forgot_password: {
		path: '/forgot-password',
	},
	reset_password: {
		path: '/reset-password/:id/:token',
	},
	reset_password_success: {
		path: '/reset-password-success',
	},
	buyer_library: {
		path: '/buyer',
		buyer_list: {
			path: '/buyer/buyer_list',
		},
		leads: {
			path: '/buyer/leads',
		},
		wizshop_users: {
			path: '/buyer/wizshop_users',
		},
		abandoned_cart: {
			path: '/buyer/abandoned_cart',
		},
		wiz_shop_list: {
			path: '/buyer-library/wizshop-list',
		},
		create_buyer: {
			path: '/buyer-library/create-buyer',
		},
		view_buyer: {
			path: '/buyer-library/view-buyer/:id',
			routing_path: '/buyer-library/view-buyer/',
		},
		view_lead: {
			path: '/buyer-library/view-lead/:id',
			routing_path: '/buyer-library/view-lead/',
		},
		edit_buyer: {
			path: '/buyer-library/edit-buyer/:id',
			routing_path: '/buyer-library/edit-buyer',
		},
	},
	error_not_found: {
		path: '/404',
	},
	order_management: {
		path: 'order',
		// all_list: {
		// 	path: '/order-listing/all',
		// },
		order_list: {
			path: '/order-listing/order',
		},
		quote_list: {
			path: '/order-listing/quote',
		},
		draft_list: {
			path: '/order-listing/draft',
		},
		invoices: {
			path: '/order-listing/invoices',
		},
		payments: {
			path: '/order-listing/payments',
		},
		catalogs: {
			path: '/order-listing/catalogs',
		},
		credit_memo: {
			path: '/order-listing/credit_memo',
		},
		abandoned_carts: {
			path: '/buyer/abandoned_cart',
		},
	},
	redirect: {
		path: '/redirect',
	},
	ella_review_order: {
		path: '/ella-review-order/:id',
		routing_path: '/ella-review-order',
	},
	ella_confirm_order: {
		path: '/ella-confirm-order/:id',
		routing_path: 'ella-confirm-order',
	},
	view_submission: {
		path: '/view/:id',
		routing_path: 'view',
	},
	ella_order_comparison: {
		path: '/ella-order-comparison/:id',
		routing_path: 'ella-order-comparison',
	},

	ella_listing_page: {
		path: '/',
	},
	ella_multi_po_listing_page: {
		path: '/ella-multipo-listing/:id',
		routing_path: 'ella-multipo-listing',
	},
	nylas_callback: {
		path: '/nylas-callback',
	},
	settings: {
		path: '/settings',
		general_settings: {
			path: '/settings/general-settings',
		},
		email_settings: {
			path: '/settings/email-settings',
		},
		advanced_settings: {
			path: '/settings/advanced-settings',
		},
		user_management_system: {
			path: '/user-management',
			routing_path: '/user-management',
		},
	},
	prompt_management: {
		path: '/prompt-management',
	},
	manual_upload: {
		path: '/manual-upload',
		routing_path: '/manual-upload',
	},
	impersonate: {
		path: '/impersonate',
	},
};

const authRouterRoutes = [
	{
		path: RouteNames.impersonate.path,
		element: (
			<Suspense fallback={<LoaderScreen />}>
				<Impersonate />
			</Suspense>
		),
	},
	{
		path: RouteNames.home.path,
		element: (
			<Suspense fallback={<LoaderScreen />}>
				<Login />
			</Suspense>
		),
	},
	{
		path: RouteNames.forgot_password.path,
		element: (
			<Suspense fallback={<LoaderScreen />}>
				<ForgotPassword />
			</Suspense>
		),
	},
	{
		path: RouteNames.login_two_factor.path,
		element: (
			<Suspense fallback={<LoaderScreen />}>
				<LoginTwoFactor />
			</Suspense>
		),
	},
	{
		path: RouteNames.reset_password.path,
		element: (
			<Suspense fallback={<LoaderScreen />}>
				<ResetPassword />
			</Suspense>
		),
	},
	{
		path: RouteNames.reset_password_success.path,
		element: (
			<Suspense fallback={<LoaderScreen />}>
				<ResetPasswordConfirmation />
			</Suspense>
		),
	},
	{
		path: '*',
		element: (
			<Suspense fallback={<LoaderScreen />}>
				<Login />
			</Suspense>
		),
	},
];

/** New instance after logout so stale `/login/2fa` from the data router is not reused (fixes post-logout 2FA flash). */
export const createFreshAuthRouter = () => createBrowserRouter(authRouterRoutes);

export const DowntimeRouter = createBrowserRouter([
	{
		path: '*',
		element: (
			<Suspense fallback={<LoaderScreen />}>
				<DowntimePage />
			</Suspense>
		),
	},
]);

export const MainRouter = createBrowserRouter([
	{
		path: RouteNames.impersonate.path,
		element: (
			<Suspense fallback={<LoaderScreen />}>
				<Impersonate />
			</Suspense>
		),
	},
	{
		path: RouteNames.home.path,
		element: (
			<Suspense fallback={<LoaderScreen />}>
				<MainLayout />
			</Suspense>
		),
		children: [
			{
				path: RouteNames.ella_listing_page.path,
				element: (
					<Suspense fallback={<LoaderScreen />}>
						<EmailsListingPage />
					</Suspense>
				),
			},
			{
				path: RouteNames.ella_review_order.path,
				element: (
					<Suspense fallback={<LoaderScreen />}>
						<ReviewOrder />
					</Suspense>
				),
			},
			{
				path: RouteNames.ella_confirm_order.path,
				element: (
					<Suspense fallback={<LoaderScreen />}>
						<OrderConfirmed />
					</Suspense>
				),
			},
			{
				path: RouteNames.view_submission.path,
				element: (
					<Suspense fallback={<LoaderScreen />}>
						<ViewSubmission />
					</Suspense>
				),
			},
			{
				path: RouteNames.ella_order_comparison.path,
				element: (
					<Suspense fallback={<LoaderScreen />}>
						<OrderComparison />
					</Suspense>
				),
			},
			{
				path: RouteNames.ella_multi_po_listing_page.path,
				element: (
					<Suspense fallback={<LoaderScreen />}>
						<MultiPoListingPage />
					</Suspense>
				),
			},
			{
				path: RouteNames.settings.general_settings.path,
				element: (
					<Suspense fallback={<LoaderScreen />}>
						<GeneralSettings />
					</Suspense>
				),
			},
			{
				path: RouteNames.settings.advanced_settings.path,
				element: (
					<Suspense fallback={<LoaderScreen />}>
						<AdvancedSettings />
					</Suspense>
				),
			},
			{
				path: RouteNames.settings.email_settings.path,
				element: (
					<Suspense fallback={<LoaderScreen />}>
						<NylasEmailSettings />
					</Suspense>
				),
			},
			{
				path: RouteNames.login_two_factor.path,
				element: (
					<Suspense fallback={<LoaderScreen />}>
						<Navigate to={RouteNames.home.path} replace={true} />
					</Suspense>
				),
			},
			{
				path: RouteNames.nylas_callback.path,
				element: (
					<Suspense fallback={<LoaderScreen />}>
						<NylasCallback />
					</Suspense>
				),
			},
			{
				path: RouteNames.prompt_management.path,
				element: (
					<Suspense fallback={<LoaderScreen />}>
						<PromptManagement />
					</Suspense>
				),
			},
			{
				path: RouteNames.error_not_found.path,
				element: (
					<Suspense fallback={<LoaderScreen />}>
						<NotFound404 />
					</Suspense>
				),
			},
			{
				path: RouteNames.manual_upload.path,
				element: (
					<Suspense fallback={<LoaderScreen />}>
						<ManualUpload />
					</Suspense>
				),
			},
			{
				path: RouteNames.settings.user_management_system.path,
				element: (
					<Suspense fallback={<LoaderScreen />}>
						<UserManagementSystem />
					</Suspense>
				),
			},
		],

		// children: [
		// 	{
		// 		path: RouteNames.reports.sales_report.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<MetabaseReporting />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.reports.buyers_report.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<MetabaseReporting />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.reports.product_report.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<MetabaseReporting />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.reports.teams_report.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<MetabaseReporting />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.dashboard.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.view_dashboard.slug} a={PERMISSIONS.view_dashboard.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <CommonDashboard /> : <ProductListing />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.engine.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Engine />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.engine.listing.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<WorkFlowListing />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.forgot_password.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Navigate to={RouteNames.home.path} replace={true} />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.reset_password.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Navigate to={RouteNames.home.path} replace={true} />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.reset_password_success.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Navigate to={RouteNames.home.path} replace={true} />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.short_url.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<ShortUrlLogout />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.cart.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<CartSummary />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.product.product_detail.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<ProductDetails />
		// 			</Suspense>
		// 		), // No slug available
		// 	},
		// 	{
		// 		path: RouteNames.product.product_detail.related_product.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<ViewAllRecommended type={'related-products'} />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.product.all_products.category.path,
		// 		// element: <CategoryHome />,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<CategoryHome />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.product.all_products.collection.path,
		// 		// element: <CollectionHome />,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<CollectionHome />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.product.all_products.kai_rails.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<ViewAllKaiRails />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.product.all_products.kai_rail_products.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<ViewAllKaiProducts />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.product.all_products.recommendation.path,
		// 		// element: <ViewAllRecommended />,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<ViewAllRecommended />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.product.all_products.previously_ordered.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<ViewAllRecommended type={'previous_order'} />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.product.all_products.abandoned_cart.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<ViewAllRecommended type={'abandoned_cart'} />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.product.all_products.review.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<ReviewProductListing />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.product.all_products.review.edit.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<ReviewProductListing is_edit_mode={true} />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.inventory.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				{' '}
		// 				<InventoryManagement />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.user_management.users.path,
		// 		// element: <UserManagement />,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.view_user.slug} a={PERMISSIONS.view_user.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <UserManagement /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	// {
		// 	// 	// [TODO] [Suyash] Change to catalog while merge
		// 	// 	path: RouteNames.catelog_manager.path,
		// 	// 	element: (
		// 	// 		<Suspense fallback={<LoaderScreen />}>
		// 	// 			<Can I={PERMISSIONS.view_catalog.slug} a={PERMISSIONS.view_catalog.permissionType} passThrough>
		// 	// 				{(allowed: any) => (allowed ? <CatalogManager /> : <NotAllowed />)}
		// 	// 			</Can>
		// 	// 		</Suspense>
		// 	// 	),
		// 	// },
		// 	{
		// 		path: RouteNames.user_management.roles.path,
		// 		// element: <UserManagement />,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.view_role.slug} a={PERMISSIONS.view_role.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <UserManagement /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.user_management.add_role.path,
		// 		// element: <UserManagement />,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.create_role.slug} a={PERMISSIONS.create_role.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <UserManagement /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.user_management.edit_role.path,
		// 		// element: <UserManagement />,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.edit_role.slug} a={PERMISSIONS.edit_role.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <UserManagement /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.user_management.add_user.path,
		// 		// element: <UserManagement />,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.create_user.slug} a={PERMISSIONS.create_user.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <UserManagement /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.user_management.edit_user.path,
		// 		// element: <UserManagement />,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.edit_user.slug} a={PERMISSIONS.edit_user.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <UserManagement /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.product.all_products.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<ProductListing />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.product.all_products.search.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<ProductListing />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.product.review.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.view_orders.slug} a={PERMISSIONS.view_orders.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <OrderManagement /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.product.submitted_page.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<OrderEndStatusPage />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.buyer_library.path,
		// 		element: <BuyerListing />,
		// 		children: [
		// 			{
		// 				path: RouteNames.buyer_library.buyer_list.path,
		// 				element: <></>,
		// 			},
		// 			{
		// 				path: RouteNames.buyer_library.wizshop_users.path,
		// 				element: <></>,
		// 			},

		// 			{
		// 				path: RouteNames.buyer_library.leads.path,
		// 				element: <></>,
		// 			},
		// 			{
		// 				path: RouteNames.buyer_library.abandoned_cart.path,
		// 				element: <></>,
		// 			},
		// 		],
		// 	},
		// 	{
		// 		path: RouteNames.buyer_library.wiz_shop_list.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.view_buyers.slug} a={PERMISSIONS.view_buyers.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <WizShopList /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.buyer_library.create_buyer.path,
		// 		// element: <AddEditBuyerFlow />,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.create_buyers.slug} a={PERMISSIONS.create_buyers.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <AddEditBuyerFlow /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.buyer_library.view_buyer.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.view_buyers.slug} a={PERMISSIONS.view_buyers.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <ViewBuyerDetails /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.buyer_library.view_lead.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<ViewLeadDetails />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.buyer_library.edit_buyer.path,
		// 		// element: <AddEditBuyerFlow />,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.edit_buyers.slug} a={PERMISSIONS.edit_buyers.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <AddEditBuyerFlow /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.buyer_group.create_group.path,
		// 		// element: <CreateForm />,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.create_buyer_group.slug} a={PERMISSIONS.create_buyer_group.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <CreateForm /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.buyer_group.edit_group.path,
		// 		// element: <CreateForm />,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.edit_buyer_group.slug} a={PERMISSIONS.edit_buyer_group.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <CreateForm /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.buyer_group.view_group.path,
		// 		// element: <BuyerGroupListing />,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.view_buyer_group.slug} a={PERMISSIONS.view_buyer_group.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <BuyerGroupListing /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.buyer_group.buyer_list.path,
		// 		// element: <BuyersListing />,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.view_buyers.slug} a={PERMISSIONS.view_buyers.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <BuyersListing /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},

		// 	{
		// 		path: RouteNames.lead.lead_listing.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<LeadsListingLayout />
		// 			</Suspense>
		// 		),
		// 		children: [
		// 			{
		// 				path: RouteNames.lead.lead_listing.all.path,
		// 				element: <></>,
		// 			},
		// 			{
		// 				path: RouteNames.lead.lead_listing.tab.path,
		// 				element: <></>,
		// 			},
		// 		],
		// 	},
		// 	{
		// 		path: RouteNames.lead.create_lead_form.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<AddEditLeadFlow />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.lead.edit_lead.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<AddEditLeadFlow />
		// 			</Suspense>
		// 		),
		// 	},

		// 	{
		// 		path: RouteNames.product.all_products.category_listing.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<ProductListingPageByType />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.product.all_products.collection_listing.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<ProductListingPageByType />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.product.all_products.custom.path,
		// 		// element: <ViewAllCustom />,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<ViewAllCustom />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.labels.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.create_labels.slug} a={PERMISSIONS.create_labels.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <LabelManagement /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.pim.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.view_product_management.slug} a={PERMISSIONS.view_product_management.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <PIM /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.product.edit_product.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.edit_product_management.slug} a={PERMISSIONS.edit_product_management.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <AddEditProductFlow /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	// {
		// 	// 	path: RouteNames.buyer_dashboard.path,
		// 	// 	element: (
		// 	// 		<Suspense fallback={<LoaderScreen />}>
		// 	// 			<Can I={PERMISSIONS.view_dashboard.slug} a={PERMISSIONS.view_dashboard.permissionType} passThrough>
		// 	// 				{(allowed: any) => (allowed ? <BuyerDashboard /> : <NotAllowed />)}
		// 	// 			</Can>
		// 	// 			<BuyerDashboard />
		// 	// 		</Suspense>
		// 	// 	),
		// 	// },
		// 	{
		// 		path: RouteNames.payment.collect_payment.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<PaymentForm />,
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.payment.direct_payment.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<PaymentForm />,
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.payment.refund_payment.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<PaymentForm />,
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.payment.subscription_payment.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<PaymentForm />,
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.payment.edit_payment_details.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<PaymentForm />,
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.payment.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<PaymentLayoutComp persist_tabs={true} />
		// 			</Suspense>
		// 		),
		// 		children: [
		// 			{
		// 				path: RouteNames.payment.transactions.path,
		// 				element: <></>,
		// 			},
		// 			{
		// 				path: RouteNames.payment.recurring_payments.path,
		// 				element: <></>,
		// 			},
		// 		],
		// 	},
		// 	{
		// 		path: RouteNames.payment.authorize.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<PaymentForm />,
		// 			</Suspense>
		// 		),
		// 	},
		// 	// {
		// 	// 	path: RouteNames.payment.path,
		// 	// 	element: (
		// 	// 		<Suspense fallback={<LoaderScreen />}>
		// 	// 			<Payment />
		// 	// 		</Suspense>
		// 	// 	),
		// 	// 	children: [
		// 	// 		{
		// 	// 			path: RouteNames.payment.transactions.path,
		// 	// 			element: <Transactions />,
		// 	// 		},
		// 	// 		{
		// 	// 			path: RouteNames.payment.transactions.path,
		// 	// 			element: <Subscriptions />,
		// 	// 		},
		// 	// 	],
		// 	// },
		// 	{
		// 		path: RouteNames.discount.discount_listing.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.view_discount.slug} a={PERMISSIONS.view_discount.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <DiscountListing /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.discount.customer_segment_listing.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.view_discount.slug} a={PERMISSIONS.view_discount.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <DiscountListing /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.discount.product_segment_listing.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.view_discount.slug} a={PERMISSIONS.view_discount.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <DiscountListing /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},

		// 	{
		// 		path: RouteNames.discount.nudges.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.view_discount.slug} a={PERMISSIONS.view_discount.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <DiscountListing /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.discount.create_discount.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.create_discount.slug} a={PERMISSIONS.create_discount.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <DiscountCampaign /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.discount.edit_discount.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.create_discount.slug} a={PERMISSIONS.create_discount.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <DiscountCampaign /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.discount.view_discount.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.view_discount.slug} a={PERMISSIONS.view_discount.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <DiscountCampaign /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.discount.create_segment.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.create_discount.slug} a={PERMISSIONS.create_discount.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <DiscountSegment /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.discount.view_segment.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.view_discount.slug} a={PERMISSIONS.view_discount.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <DiscountSegment /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: '/order-listing',
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.view_orders.slug} a={PERMISSIONS.view_orders.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <AllListing /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 		children: [
		// 			// {
		// 			// 	path: RouteNames.order_management.all_list.path,
		// 			// 	element: <></>,
		// 			// },
		// 			{
		// 				path: RouteNames.order_management.draft_list.path,
		// 				element: <></>,
		// 			},
		// 			{
		// 				path: RouteNames.order_management.order_list.path,
		// 				element: <></>,
		// 			},
		// 			{
		// 				path: RouteNames.order_management.quote_list.path,
		// 				element: <></>,
		// 			},
		// 			{
		// 				path: RouteNames.order_management.invoices.path,
		// 				element: <></>,
		// 			},
		// 			{
		// 				path: RouteNames.order_management.payments.path,
		// 				element: <></>,
		// 			},
		// 			{
		// 				path: RouteNames.order_management.catalogs.path,
		// 				element: <></>,
		// 			},
		// 			{
		// 				path: RouteNames.order_management.credit_memo.path,
		// 				element: <></>,
		// 			},
		// 		],
		// 	},
		// 	{
		// 		path: RouteNames.reports.main.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.view_reports.slug} a={PERMISSIONS.view_reports.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <Reporting /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.manage_data.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.import_export.slug} a={PERMISSIONS.import_export.permissionType} passThrough>
		// 					{(allowed: any) => (allowed ? <ManageData /> : <NotAllowed />)}
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.catalog.create.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.create_catalog.slug} a={PERMISSIONS.create_catalog.permissionType} passThrough>
		// 					<CreateCatalog />
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.catalog.edit.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Can I={PERMISSIONS.edit_catalog.slug} a={PERMISSIONS.edit_catalog.permissionType} passThrough>
		// 					<EditCatalog />
		// 				</Can>
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.wishlist.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<Wishlist />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.wishlist.promoted_wishlist.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<PromotedWishlist />
		// 			</Suspense>
		// 		),
		// 	},

		// 	{
		// 		path: RouteNames.wishlist.details.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<WishlistDetails />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.task_listing.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<TaskListingLayout />
		// 			</Suspense>
		// 		),
		// 		children: [
		// 			{
		// 				path: RouteNames.task_listing.all.path,
		// 				element: <></>,
		// 			},
		// 			{
		// 				path: RouteNames.task_listing.completed.path,
		// 				element: <></>,
		// 			},
		// 			{
		// 				path: RouteNames.task_listing.due_today.path,
		// 				element: <></>,
		// 			},
		// 			{
		// 				path: RouteNames.task_listing.overdue.path,
		// 				element: <></>,
		// 			},
		// 			{
		// 				path: RouteNames.task_listing.upcoming.path,
		// 				element: <></>,
		// 			},
		// 		],
		// 	},
		// 	{
		// 		path: RouteNames.customer_visit.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<CustomerVisitLayout />
		// 			</Suspense>
		// 		),
		// 		children: [
		// 			{
		// 				path: RouteNames.customer_visit.all.path,
		// 				element: <></>,
		// 			},
		// 			{
		// 				path: RouteNames.customer_visit.last_7_days.path,
		// 				element: <></>,
		// 			},
		// 			{
		// 				path: RouteNames.customer_visit.last_3_months.path,
		// 				element: <></>,
		// 			},
		// 		],
		// 	},

		// 	{
		// 		path: RouteNames.task_listing.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<TaskListingLayout />
		// 			</Suspense>
		// 		),
		// 		children: [
		// 			{
		// 				path: RouteNames.task_listing.all.path,
		// 				element: <></>,
		// 			},
		// 			{
		// 				path: RouteNames.task_listing.completed.path,
		// 				element: <></>,
		// 			},
		// 			{
		// 				path: RouteNames.task_listing.due_today.path,
		// 				element: <></>,
		// 			},
		// 			{
		// 				path: RouteNames.task_listing.overdue.path,
		// 				element: <></>,
		// 			},
		// 			{
		// 				path: RouteNames.task_listing.upcoming.path,
		// 				element: <></>,
		// 			},
		// 		],
		// 	},
		// 	{
		// 		path: RouteNames.customer_visit.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<CustomerVisitLayout />
		// 			</Suspense>
		// 		),
		// 		children: [
		// 			{
		// 				path: RouteNames.customer_visit.all.path,
		// 				element: <></>,
		// 			},
		// 			{
		// 				path: RouteNames.customer_visit.last_7_days.path,
		// 				element: <></>,
		// 			},
		// 			{
		// 				path: RouteNames.customer_visit.last_3_months.path,
		// 				element: <></>,
		// 			},
		// 		],
		// 	},
		// 	{
		// 		path: RouteNames.mailgunemail.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<MailGunEmail />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.bulk_update_images.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<BulkUpdateImages />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.bulk_update_history.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<BulkUpdateHistory />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.settings.path,
		// 		element: (
		// 			// <Can I={PERMISSIONS.org_settings.slug} a={PERMISSIONS.org_settings.permissionType} passThrough>
		// 			<Settings />
		// 			// </Can>
		// 		),
		// 		children: [
		// 			{
		// 				path: RouteNames.settings.general.path,
		// 				children: [
		// 					{ path: RouteNames.settings.general.company_info.path, element: <GeneralMain /> },
		// 					{ path: RouteNames.settings.general.subscription.path, element: <AppSubscription /> },
		// 					{ path: RouteNames.settings.general.email_setting.path, element: <EmailSettings /> },
		// 					{ path: RouteNames.settings.general.barcode_setting.path, element: <BarcodeSettings /> },
		// 					{ path: RouteNames.settings.general.dashboard_setting.path, element: <DashboardSettings /> },
		// 					{ path: RouteNames.settings.general.import_setting.path, element: <ImportExportSettings /> },
		// 					{ path: RouteNames.settings.general.json_rule.path, element: <RuleEngine /> },
		// 					{ path: RouteNames.settings.general.pricelist.path, element: <Pricelist /> },
		// 				],
		// 			},
		// 			{
		// 				path: RouteNames.settings.inventory.path,
		// 				children: [
		// 					{ path: RouteNames.settings.inventory.inventory.path, element: <Inventory /> },
		// 					{ path: RouteNames.settings.inventory.inventory_display.path, element: <InventoryDisplay /> },
		// 				],
		// 			},
		// 			{
		// 				path: RouteNames.settings.reporting.path,
		// 				children: [{ path: RouteNames.settings.reporting.reports.path, element: <ReportSettings /> }],
		// 			},
		// 			{
		// 				path: RouteNames.settings.buyer.path,
		// 				children: [
		// 					{ path: RouteNames.settings.buyer.form.path, element: <Buyer /> },
		// 					{ path: RouteNames.settings.buyer.permission.path, element: <CustomerPermission /> },
		// 					{ path: RouteNames.settings.buyer.other.path, element: <BuyerOthers /> },
		// 				],
		// 			},
		// 			{
		// 				path: RouteNames.settings.order_management.path,
		// 				children: [
		// 					{ path: RouteNames.settings.order_management.document.path, element: <Document /> },
		// 					{ path: RouteNames.settings.order_management.document_permission.path, element: <DocumentPermission /> },
		// 					{ path: RouteNames.settings.order_management.charges.path, element: <CartSummarySettings /> },
		// 					{ path: RouteNames.settings.order_management.sales.path, element: <Sales /> },
		// 					{ path: RouteNames.settings.order_management.tags.path, element: <TagSetting /> },
		// 					{ path: RouteNames.settings.order_management.document_numbers.path, element: <DocumentNumbers entity='document' /> },
		// 				],
		// 			},
		// 			{
		// 				path: RouteNames.settings.cart_summary.path,
		// 				children: [
		// 					{ path: RouteNames.settings.cart_summary.cart_conatiner.path, element: <ContainerSetting /> },
		// 					{ path: RouteNames.settings.cart_summary.cart_grouping.path, element: <CartGrouping /> },
		// 				],
		// 			},
		// 			{
		// 				path: RouteNames.settings.crm.path,
		// 				children: [
		// 					{ path: RouteNames.settings.crm.task_form.path, element: <TaskFormSetting /> },
		// 					{ path: RouteNames.settings.crm.crm_settings.path, element: <CRMSettings /> },
		// 				],
		// 			},
		// 			{
		// 				path: RouteNames.settings.user_setting.path,
		// 				children: [{ path: RouteNames.settings.user_setting.setting_config.path, element: <SettingConfig /> }],
		// 			},
		// 			{
		// 				path: RouteNames.settings.template.path,
		// 				children: [
		// 					{ path: RouteNames.settings.template.tear_sheet_pdf.path, element: <TearSheet /> },
		// 					{ path: RouteNames.settings.template.tear_sheet_excel.path, element: <ExcelSheets /> },
		// 					{ path: RouteNames.settings.template.label.path, element: <Labels /> },
		// 				],
		// 			},
		// 			{
		// 				path: RouteNames.settings.product.path,
		// 				children: [
		// 					{ path: RouteNames.settings.product.product_details.path, element: <ProductDetailsSetting /> },
		// 					{ path: RouteNames.settings.product.listing.path, element: <Listing /> },
		// 					{ path: RouteNames.settings.product.category_collection.path, element: <CategoryCollectionAttr /> },
		// 					{ path: RouteNames.settings.product.pim.path, element: <PIMListing /> },
		// 				],
		// 			},
		// 			{
		// 				path: RouteNames.settings.user_management.path,
		// 				children: [{ path: RouteNames.settings.user_management.showroom_mode.path, element: <ShowroomModeSetting /> }],
		// 			},
		// 			{
		// 				path: RouteNames.settings.email_setting.path,
		// 				children: [
		// 					{ path: RouteNames.settings.email_setting.set_reminders.path, element: <SetReminder /> },
		// 					{ path: RouteNames.settings.email_setting.email_config.path, element: <EmailConfig /> },
		// 					{ path: RouteNames.settings.email_setting.external_email.path, element: <EmailTrigger type='external' /> },
		// 					{ path: RouteNames.settings.email_setting.internal_email.path, element: <EmailTrigger type='internal' /> },
		// 				],
		// 			},
		// 			{
		// 				path: RouteNames.settings.others.path,
		// 				children: [{ path: RouteNames.settings.others.incremental_sync.path, element: <IncrementalSync /> }],
		// 			},
		// 			{
		// 				path: RouteNames.settings.payment.path,
		// 				children: [{ path: RouteNames.settings.payment.payment_terms.path, element: <PaymentTerms /> }],
		// 			},
		// 			{
		// 				path: RouteNames.settings.country_state.path,
		// 				children: [
		// 					{ path: RouteNames.settings.country_state.country_settings.path, element: <CountrySettings /> },
		// 					{ path: RouteNames.settings.country_state.state_settings.path, element: <StateSettings /> },
		// 				],
		// 			},
		// 			{
		// 				path: RouteNames.settings.integration.path,
		// 				children: [{ path: '', element: <QBOIntegration /> }],
		// 			},
		// 		],
		// 	},
		// 	{
		// 		path: RouteNames.user_drive.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<UserDrive />
		// 			</Suspense>
		// 		),
		// 	},
		// 	{
		// 		path: RouteNames.user_drive.search.path,
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<UserDrive />
		// 			</Suspense>
		// 		),
		// 	},
		// {
		// 	path: RouteNames.error_not_found.path,
		// 	element: (
		// 		<Suspense fallback={<LoaderScreen />}>
		// 			<NotFound404 />
		// 		</Suspense>
		// 	),
		// },
		// 	{
		// 		path: '*',
		// 		element: (
		// 			<Suspense fallback={<LoaderScreen />}>
		// 				<NotAllowed />
		// 			</Suspense>
		// 		),
		// 	},
		// ],
	},
]);

export default RouteNames;
